var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSf = function SvgSf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: 80,
    id: "Outline",
    viewBox: "0 0 64 64",
    width: 80,
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y: "0px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,41c-0.55225,0-1,0.44775-1,1v6c0,0.55225,0.44775,1,1,1h4c0.55225,0,1-0.44775,1-1v-6c0-0.55225-0.44775-1-1-1H14z  M17,47h-2v-4h2V47z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,39c0.55225,0,1-0.44775,1-1v-6c0-0.55225-0.44775-1-1-1h-4c-0.55225,0-1,0.44775-1,1v6c0,0.55225,0.44775,1,1,1H23z  M20,33h2v4h-2V33z",
    fill: "#05F283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,37c-0.55225,0-1,0.44775-1,1v6c0,0.55225,0.44775,1,1,1h4c0.55225,0,1-0.44775,1-1v-6c0-0.55225-0.44775-1-1-1H27z  M30,43h-2v-4h2V43z",
    fill: "#05F283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,31c0.55225,0,1-0.44775,1-1v-2c0-0.55225-0.44775-1-1-1h-4c-0.55225,0-1,0.44775-1,1v10c0,0.55225,0.44775,1,1,1h4 c0.55225,0,1-0.44775,1-1v-4c0-0.55225-0.44775-1-1-1s-1,0.44775-1,1v3h-2v-8h2v1C37,30.55225,37.44775,31,38,31z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,21v10c0,0.55225,0.44775,1,1,1h4c0.55225,0,1-0.44775,1-1V21c0-0.55225-0.44775-1-1-1h-4 C41.44775,20,41,20.44775,41,21z M43,22h2v8h-2V22z",
    fill: "#05F283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,45h4c0.55225,0,1-0.44775,1-1V31c0-0.55225-0.44775-1-1-1s-1,0.44775-1,1v12h-2V13h2v14c0,0.55225,0.44775,1,1,1 s1-0.44775,1-1V12c0-0.55225-0.44775-1-1-1h-4c-0.55225,0-1,0.44775-1,1v32C49,44.55225,49.44775,45,50,45z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,51H8c-0.55225,0-1,0.44775-1,1s0.44775,1,1,1h48c0.55225,0,1-0.44775,1-1S56.55225,51,56,51z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.00012,33.98944c0.25946-0.00006,0.5188-0.0943,0.70691-0.28241L23,21.41406l5.29297,5.29297 c0.39062,0.39062,1.02344,0.39062,1.41406,0L42,14.41406V16c0,0.55225,0.44775,1,1,1s1-0.44775,1-1v-4c0-0.55225-0.44775-1-1-1h-4 c-0.55225,0-1,0.44775-1,1s0.44775,1,1,1h1.58594L29,24.58594l-5.29297-5.29297c-0.39062-0.39062-1.02344-0.39062-1.41406,0 c0,0-12.95172,12.95172-12.99988,12.99988C8.68671,32.89923,9.14856,33.98956,10.00012,33.98944z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sf.094dccbf579c2c5d42eeb31fc8a2029d.svg";